import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function BackButton({ label = 'Kembali' }) {
  const navigate = useNavigate()
  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-2 mb-6 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition"
    >
      <ArrowLeft size={18} />
      <span>{label}</span>
    </button>
  )
}
